module.exports = __webpack_public_path__ + "img/icon_caja.46db4d15.svg";